import React from "react";
import "../post.css";
import DayTwo from "../images/day_two.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Two</h2>
        <img className="image" alt="itinerary" src={DayTwo} />
        <div className="infobar">
          <div className="info">21 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Shinjuku. Shopping and business like atmosphere. It's also a major
          transportation hub. Not too far from Shinjuku, Yoyogi Park is a garden
          in the city that's beautiful to walk.
        </p>
        <h3>Evening</h3>
        <p>
          Shibuya. Explore modern culture and the busiest crossing in Japan.
          Heavy with entertainment, neon lights, and night clubs. Dinner will be
          at Genki Sushi, Shibuya, where bots run along conveyor belts bringing
          you your orders.
        </p>
      </div>
    );
  }
}
